module.exports = __webpack_public_path__ + "img/traceinsight-logo.5fa27b89.png";